import store from '@/state/store'
const fields = [
  {
    key: 'createdOn',
    label: 'global.field.date',
    header: 'date',
    filter: false,
    width: 20,
    disabled: true,
  },
  {
    key: 'vehicle',
    label: 'report.fields.licensePlate',
    header: 'licensePlate',
    filter: true,
    width: 20,
  },
  {
    key: 'vehicleType',
    label: 'report.fields.vehicleType',
    header: 'vehicleType',
    filter: false,
    width: 30,
  },
  {
    key: 'acc',
    label: 'report.object.acc',
    header: 'acc',
    filter: false,
    width: 10,
  },
  {
    key: 'refrigerator',
    label: 'report.fields.refrigerator',
    header: 'refrigerator',
    filter: false,
    width: 10,
  },
  {
    key: 'temperature',
    label: 'report.fields.temperatureCensor1',
    header: 'temperature',
    filter: false,
    width: 10,
  },
  {
    key: 'temperature2',
    label: 'report.fields.temperatureCensor2',
    header: 'temperature2',
    filter: false,
    width: 10,
  },
  {
    key: 'temperature3',
    label: 'report.fields.temperatureCensor3',
    header: 'temperature3',
    filter: false,
    width: 10,
  },
  {
    key: 'door1',
    label: 'report.fields.censorDoor1',
    header: 'door1',
    filter: false,
    width: 10,
    disabled: false,
  },
  {
    key: 'door2',
    label: 'report.fields.censorDoor2',
    header: 'door2',
    filter: false,
    width: 10,
    disabled: false,
  },
  {
    key: 'address',
    label: 'report.fields.location',
    header: 'address',
    filter: false,
    width: 10,
  },
]
if (store.getters['identity/hasAccess'](['temperature_geofence_column:read'])) {
  fields.splice(10, 0, {
    key: 'geofence',
    label: 'report.fields.geolocation',
    header: 'geofence',
    filter: false,
    width: 30,
  })
}
export default fields
